module.exports = __webpack_public_path__ + "static/media/book.11d9b18b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/book.svg
// module id = 117
// module chunks = 6